import React, { Component }  from 'react';
import SearchBox from '../SearchBox';
import ProductionOrderList from '../ProductionOrderList';
import { GETCOMPLETEDPRODUCTIONORDERS } from '../../constants/Config';
import { useTranslation, Trans } from 'react-i18next';
import { toast } from 'react-toastify';
const { t } = useTranslation();

class OrderHistoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          isLoaded: false,
          orders: [],
          recentorders: []
        };
        this.searchOrdersWithFilter = this.searchOrdersWithFilter.bind(this);
    }

    componentDidMount() {
        this.props.setHeader();

        if(this.props.searchText != "") {
            this.searchOrdersWithFilter(this.props.searchText);
        }
    };

    searchOrdersWithFilter(filter) {
        if(filter.trim() !== "") {
            fetch(GETCOMPLETEDPRODUCTIONORDERS + filter +"/5", {method: 'GET'})
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    if (!response.ok) {
                        const error = (data && data.message) || response.statusText;
                        return Promise.reject(error);
                    }
            
                    return data;
                });
            })
            .then((res) => {
                    this.setState({
                    isLoaded: true,
                    orders: res.results
                    });
    
                    if(res.results.length === 0) {
                        toast.info(<Trans>{t('NoOrders')}</Trans>, {
                            position: toast.POSITION.TOP_CENTER
                          });
                    }

                    this.props.setOrderHist(filter);
            })
            .catch(function(error) {
                toast.error(error, {
                    position: toast.POSITION.TOP_CENTER
                  });
            });
        } else {
            toast.info(<Trans>{t("FillSearchField")}</Trans>, {
                position: toast.POSITION.TOP_CENTER
              });
        }
    }

    render() {
        return (
            <React.Fragment>
                <SearchBox SearchOrders={this.searchOrdersWithFilter} searchText={this.props.searchText}></SearchBox>
                <ProductionOrderList actions={this.props.actions} editTitle={<Trans>{t('ShowDetails')}</Trans>} orders= {this.state.orders} title={<Trans>{t('SearchOrders')}</Trans>}></ProductionOrderList>
            </React.Fragment>
        )
    }
}

export default OrderHistoryPage;